import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper py-20 sm:py-24" aria-labelledby="faq-title" data-id="element-61" data-mp="1lcagbdy30p6l">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-62" data-mp="1gdqst93ub5c4">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-63" data-mp="2e0g1g1t1sg6y">Antes de decidir</p>
        <h2 id="faq-title" className="mt-4 text-center font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-64" data-mp="290tnfq5eavx3">
          Preguntas frecuentes
        </h2>
        <ul className="mt-10 space-y-3" data-id="element-65" data-mp="24435sydxzs9k">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          const id = `faq-${i}`;
          return <li key={i} className="rounded-2xl bg-paper shadow-soft ring-1 ring-cream-line" data-id="element-66" data-mp="soo97vpnb2ez" data-mpi={i}>
                <h3 data-id="element-67" data-mp="nmgskstvey6b">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left" data-id="element-68" data-mp="nq4otzqp9yoq">
                    <span className="text-lg font-medium text-petrol" data-id="element-69" data-mp="kil3y5c6dcd2">{f.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-terra transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-70" data-mp="6rgc3pf1toda" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-71" data-mp="3t0hk7vxgnvc1">
                  {isOpen && <motion.div id={id} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-72" data-mp="1svablk5ewmq">
                      <p className="px-6 pb-6 leading-relaxed text-ink-soft" data-id="element-73" data-mp="1ppclb76iq952">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}